export default {
  studea_manager: {
    confirm_duplication: "Êtes-vous sur de vouloir dupliquer ces données ?",
    data_duplicated_success: "Données dupliquées avec succès",
    delete_session_confirmation: "Êtes-vous sûr de vouloir supprimer cette période ?",
    delete_referential_confirmation: "Êtes-vous sûr de vouloir supprimer ce référentiel ?",
    navigation: {
      general: "Général",
      modules: "Modules",
      pilotage: "Pilotage",
    },
    triadUser: {
      title: "utilisateur secondaire",
    },
    moderation: {
      title: ({ plural }) => plural(["Signalement", "Signalements"]),
      censor: "Censurer",
      restore: "Annuler le signalement",
      show: "Voir",
      show_censor: "Voir les messages censurés",
      show_message: "Voir les messages à modérer",
      file: "Fichier",
      modal_title: "Conversation",
      alert_title: "Censurer un message",
      alert_sub_title: "Voulez-vous censurer ou annuler le signalement sur ce message ?",
      censor_success: "Message censuré avec succès !",
    },
    home: {
      title: ({ plural }) => plural(["Configuration de la ", "Configuration du "]),
      page_title: "Configuration",
    },
    trainingSkillCategory: {
      title: ({ plural }) => plural(["Bloc de compétence", "Blocs de compétence"]),
      block: ({ plural }) => plural(["Bloc", "Blocs"]),
    },
    trainingSkillCriticalLearning: {
      title: ({ plural }) => plural(["Apprentissage critique", "Apprentissages critiques"]),
      level_column: "Niveau",
      content_column: "Apprentissage critique",
      level: ({ named }) => `Niveau ${named("n")}`,
      empty:
        "Aucun apprentissage critique défini pour cette compétence. Utilisez l'IA pour en générer ou modifiez la compétence pour les ajouter manuellement.",
      empty_action: "Modifier la compétence",
      collapse: "Masquer les apprentissages critiques",
      expand: "Afficher les apprentissages critiques",
      update_success: "Apprentissage critique modifié avec succès",
      update_error: "Erreur lors de la modification de l'apprentissage critique",
    },
    questionnaire: {
      title: ({ plural }) => plural(["Questionnaire", "Questionnaires"]),
      list: {
        title: "Configuration des questionnaires",
      },
      questionnaire_already_signed: "Attention le questionnaire a déjà été signé !",
      duplicate_year: {
        title: "Dupliquer vers l'année suivante",
        confirm: "Voulez-vous dupliquer tous les questionnaires de cette année vers l'année suivante ?",
        success: "Les questionnaires ont été dupliqués vers l'année suivante",
      },
      start_date: ({ named }) => `Date d'accès ${named("profile")} - du`,
      end_date: "au",

      finish: {
        title: "Terminer ma configuration",
      },
      empty_title: "Pour commencer, veuillez ajouter un titre, une question ou une grille de réponse !",
      add_question: "Ajouter une question",
      add_title: "Ajouter un titre",
      add_question_cluster: "Ajouter une grille de questions",
      required: "Obligatoire",
      question_settings: "Paramètre de la question",
      question_access: "Paramètre des accès",
      cluster_settings: "Paramètre de la grille",
      remove_question: "Supprimer la question",
      remove_cluster: "Supprimer la grille",
      remove_title: "Supprimer le titre",
      duplicate_cluster: "Dupliquer la grille",
      duplicate_question: "Dupliquer la question",
      tip: "Infobulle",
      display_mode: "Grille de réponse",
      save: "Enregistrer",
      save_success: "Questionnaire enregistré avec succès !",
      save_error: "Il y'a eu une erreur lors de l'enregistrement !",
      missing_error:
        "Attention il manque certains droits d'accès, titres aux questions, type de question ou colonne de réponse aux grille de questionnaire !",
      informations: "Informations",
      deadlines_reminders: "Échéances & relances",
      advanced_parameter: "Paramètres avancés",
      company_visit: "Visite en entreprise",
      settings: "Paramètres",
      summary: "Synthèse",
      add_column: "Ajouter une colonne",
      add_row: "Ajouter une ligne",
      row_settings: "Qui remplit ?",
      skill_settings: "Gérer les compétences liées",
      access_missing: "Les droits d'accès sont manquants pour cette question",
      title_missing: "Vous devez renseigner un titre pour cette question",
      value_title_missing: "Vous devez renseigner un titre pour cette valeur",
      duplicate_row: "Dupliquer la ligne",
      remove_row: "Supprimer la ligne",
      remove_column: "Supprimer la colonne",
      empty_line: "Ligne sans titre",
      add_skill: "Ajouter cette compétence",
      skill_category_name: "Catégorie",
      skill_name: "Nom",
      coefficient: "Coefficient",
      mission: "Mission",
      activity: "Activité",
      mission_block_title: "Missions du contrat",
      mission_preview_summary_example: "3 en cours · 1 terminée · 1 archivée",
      mission_summary_counts: "{inProgress} en cours · {completed} terminée(s) · {archived} archivée(s)",
      mission_example_name: "Développement d'une nouvelle application interne",
      mission_progress_label: "Progression",
      mission_objectives_label: "Objectifs pour cette période",
      mission_objectives_placeholder: "Décrivez les objectifs à atteindre pour cette période",
      item_filter_display_label: "Afficher",
      item_filter_completion_label: "Complétudes",
      item_filter_chronology_label: "Chronologie",
      mission_filter_all: "Toutes",
      mission_filter_in_progress: "En cours",
      mission_filter_completed: "Terminées",
      mission_filter_archived: "Archivées",
      item_sort_label: "Trier",
      mission_sort_start_date: "Date de début",
      mission_sort_end_date: "Date de fin",
      mission_comment_label: "Commentaire",
      mission_comment_placeholder: "Ajoutez un commentaire (facultatif)",
      mission_completed_badge: "Terminée",
      mission_archived_badge: "Archivée",
      mission_filter_results_count: "{count} mission(s) affichée(s)",
      mission_archive_action: "Archiver",
      mission_archive_modal_title: "Archiver une mission",
      mission_archive_warning:
        "L'archivage masque la mission de la liste active. Elle reste consultable via le filtre « Archivées ». Cette action est réversible.",
      mission_archive_reason_label: "Motif d'archivage",
      mission_archive_reason_placeholder:
        "Expliquez pourquoi cette mission est archivée (modification du périmètre, redondance, réorientation du contrat...)",
      mission_archive_submit: "Archiver la mission",
      mission_archive_success: "La mission a été archivée avec succès",
      mission_unarchive_action: "Désarchiver",
      mission_unarchive_confirm_title: "Désarchiver cette mission ?",
      mission_unarchive_confirm_text: "La mission redeviendra visible dans la liste des missions en cours.",
      mission_unarchive_success: "La mission a été désarchivée avec succès",
      mission_edit_action: "Modifier",
      mission_edit_modal_title: "Modifier une mission",
      mission_edit_confirm_title: "Confirmer la modification ?",
      mission_edit_confirm_subtitle:
        "Cette modification sera répercutée sur la mission du contrat et visible dans le récapitulatif global.",
      mission_edit_success: "La mission a été modifiée avec succès",
      mission_add_action: "Ajouter une mission",
      mission_add_label: "Ajouter",
      mission_add_modal_title: "Ajouter une mission",
      mission_add_success: "La mission a été créée avec succès",
      mission_history_action: "Voir l'historique des objectifs",
      mission_history_modal_title: "Historique des objectifs",
      mission_history_empty: "Aucun objectif n'a encore été défini pour cette mission.",
      mission_history_error: "Une erreur est survenue lors du chargement de l'historique.",
      mission_history_defined_by: "Défini par {name} ({profile}) · {date}",
      history_profile_apprentice: "Alternant",
      history_profile_tutor: "Tuteur",
      history_profile_apprenticeMaster: "MAP",
      history_profile_studeaManager: "Gestionnaire",
      activity_block_title: "Activités du contrat",
      activity_preview_summary_example: "2 en cours · 1 terminée · 1 archivée",
      activity_example_name: "Rédaction d'un rapport d'analyse",
      activity_sort_start_date: "Date de début",
      activity_sort_end_date: "Date de fin",
      activity_filter_results_count: "{count} activité(s) affichée(s)",
      activity_add_action: "Ajouter une activité",
      activity_filter_all: "Toutes",
      activity_filter_ongoing: "En cours",
      activity_filter_to_complete: "À compléter",
      activity_filter_completed: "Complètes",
      activity_filter_certified: "Certifiées",
      activity_filter_archived: "Archivées",
      activity_to_certify_badge_label: "À certifier",
      activity_to_certify_alert: "Vous avez {count} activité(s) à certifier. Afficher les activités complètes.",
      activity_filter_finished: "Terminées",
      activity_temporal_ongoing: "En cours",
      activity_temporal_finished: "Terminée",
      activity_workflow_validated: "Validée",
      activity_workflow_certified: "Certifiée",
      activity_workflow_cancelled: "Annulée",
      activity_step_creation: "Création",
      activity_step_description: "Description",
      activity_step_analysis: "Analyse",
      activity_step_skills: "Compétences",
      activity_step_validation: "Validation",
      activity_step_badge: "Étape {number} - {label}",
      activity_stepper_label: "Progression de l'activité",
      activity_step_state_done: "Étape {number} sur {total} : {label}, terminée",
      activity_step_state_current: "Étape {number} sur {total} : {label}, en cours",
      activity_step_state_todo: "Étape {number} sur {total} : {label}, à venir",
      activity_level_of_achievement: "{percent}% complété",
      activity_level_of_achievement_aria: "Complétude de l'activité : {percent}%",
      activity_edit_action: "Modifier",
      activity_certify_action: "Certifier",
      activity_view_action: "Consulter",
      activity_end_date_action: "Renseigner la date de fin",
      activity_archive_action: "Archiver",
      activity_archive_modal_title: "Archiver l'activité",
      activity_archive_warning:
        "L'activité archivée ne sera plus visible par les tuteurs. Elle reste consultable par vous-même.",
      activity_archive_submit: "Archiver",
      activity_archive_success: "Activité archivée",
      activity_unarchive_action: "Désarchiver",
      activity_unarchive_confirm_title: "Désarchiver cette activité ?",
      activity_unarchive_confirm_text:
        "L'activité repassera au statut brouillon et redeviendra visible dans la liste des activités en cours.",
      activity_unarchive_success: "L'activité a été désarchivée avec succès",
      activity_archive_not_draft: "Cette activité ne peut plus être archivée : elle a déjà été signée.",
      activity_end_date_modal_title: "Renseigner la date de fin",
      activity_end_date_info:
        "Cette date indique simplement que l'activité est terminée dans le temps. Elle n'ouvre pas la certification et ne verrouille pas le contenu de l'activité.",
      activity_end_date_label: "Date de fin",
      activity_end_date_success: "Date de fin enregistrée",
      activity_edit_modal_title: "Modifier une activité",
      activity_view_modal_title: "Consulter une activité",
      activity_add_modal_title: "Ajouter une activité",
      activity_history_action: "Historique du suivi",
      activity_history_modal_title: "Historique du suivi",
      activity_history_empty: "Aucun suivi n'a encore été renseigné pour cette activité.",
      activity_history_error: "Une erreur est survenue lors du chargement de l'historique.",
      activity_history_defined_by: "Défini par {name} ({profile}) · {date}",
      activity_comment_label: "Suivi de la réalisation sur cette période",
      activity_comment_placeholder:
        "Décrivez ce que vous avez concrètement réalisé sur cette activité durant cette période.",
      activity_commentaire_missing: "Suivi non renseigné",
      activity_linked_mission: "Mission : {name}",
      activity_no_mission_linked: "Aucune mission rattachée",
      activity_description_missing: "Description non renseignée",
      activity_skills_count: "{count} compétence(s) mobilisée(s)",
      activity_summary_counts:
        "{ongoing} en cours · {finished} terminée(s) · {toComplete} à compléter · {completed} complète(s) · {archived} archivée(s)",
      activity_summary_counts_without_archived:
        "{ongoing} en cours · {finished} terminée(s) · {toComplete} à compléter · {completed} complète(s)",
      activity_signature_summary_title: "Résumé avant validation",
      activity_signature_field_name: "Intitulé",
      activity_signature_field_type: "Type",
      activity_signature_field_missions: "Mission(s)",
      activity_signature_field_skills: "Compétences mobilisées",
      activity_signature_missions_more: ({ named }) => `${named("name")} +${named("count")}`,
      activity_signature_warning:
        "En validant, vous verrouillez le contenu de cette activité (description, analyse, compétences). Elle sera transmise à votre tuteur, qui pourra évaluer les compétences mobilisées et ajouter un commentaire. Cette action n'est pas réversible par vous-même.",
      activity_signature_sign_button: "Valider",
      activity_signature_confirm_button: "Enregistrer et valider",
      activity_signature_confirm_modal_title: "Confirmer la validation",
      activity_signature_incomplete_hint:
        "Les quatre premiers onglets doivent être complets avant de pouvoir valider cette activité.",
      activity_signature_locked_banner: ({ named }) =>
        `Cette activité a été signée par ${named("name")} le ${named("date")}. Son contenu (description, analyse, compétences) est verrouillé.`,
      activity_signature_evaluation_title: "Évaluation des compétences mobilisées",
      activity_signature_evaluation_optional_badge: "Optionnel",
      activity_signature_evaluation_subtitle:
        "Vous pouvez évaluer tout ou partie des compétences déclarées par l'alternant, ou ne pas les évaluer du tout.",
      activity_signature_certify_button: "Certifier",
      activity_signature_certify_confirm_title: "Confirmer la certification",
      activity_signature_not_evaluated: "Non évaluée",
      activity_signature_level_0: "Non mis en œuvre",
      activity_signature_level_1: "Initié",
      activity_signature_level_2: "Opérationnel",
      activity_signature_level_3: "Compétent",
      activity_signature_level_4: "Expert",
      activity_signature_certifier_comment_label: "Commentaire du tuteur (optionnel)",
      activity_signature_certifier_comment_hint: "Ce commentaire sera visible par l'alternant et le reste du trinôme.",
      activity_signature_certify_warning:
        "La certification est définitive. L'activité passera au statut « Certifiée » et ne pourra plus être modifiée par l'alternant. Les évaluations non renseignées restent « Non évaluées ».",
      activity_signature_recap_validated_by: ({ named }) => `Validée par ${named("name")} le ${named("date")}`,
      activity_signature_recap_certified_by: ({ named }) => `Certifiée par ${named("name")} le ${named("date")}`,
      activity_signature_info_awaiting_signature: "En attente de signature par l'alternant.",
      activity_signature_info_awaiting_certification: "En attente d'évaluation et de certification.",
      activity_signature_info_cancelled: "Cette activité a été archivée.",
      activity_signature_info_default: "Aucune action n'est disponible sur cet onglet pour le moment.",
      empty_column: "Titre de la colonne",
      remove_field_skill: "Suppression de la compétence liée",
      field_skill_used: "Cette compétence est déjà liée à cette question",
      remove_field_skill_sub: "Êtes-vous sûr de vouloir supprimer la liaison de cette compétence avec la question ?",
      untitled_column: "Colonne sans titre",
      remove_row_warning: "Êtes-vous sûr de vouloir supprimer cette ligne ?",
      remove_column_warning: "Êtes-vous sûr de vouloir supprimer cette colonne ?",
      untitled_questionnaire: "Formulaire sans titre",
      placeholder_description: "Ajouter votre description",
      access_profil: "Profils répondant à la question",
      field_skill: "Compétences liées à la question",
      search_skill: "Rechercher une compétence",
      opened_question_access: "Accès au questions ouvertes",
      opened_questions: "Questions ouvertes",
      opened_questions_type: "Type de questions ouvertes",
      grid_title: "Titre de la grille",
      comments_enabled: "Commentaires autorisés",
      comments_label: "Intitulé des commentaires",
      comments_type: "Type de champs commentaires",
      one_line: "Réponse courte",
      multi_line: "Zone de texte",
      maximal_mark: "Note maximum",
      mark_scale: "Barème",
      display_mark: "Utiliser les notes",
      display_radar: "Afficher le radar",
      question_title: "Titre de la question",
      infobulle_content: "Contenu de l'infobulle",
      question_comment: "Commentaire",
      field_type_choose: "Choisissez un type",
      short_answer: "Réponse courte",
      long_answer: "Réponse longue",
      textarea: "Zone de texte",
      number: "Nombre",
      dropdown_list: "Liste déroulante",
      unique_choice: "Choix unique",
      multiple_choices: "Choix multiples",
      file: "Fichier",
      date: "Date",
      question: ({ plural }) => plural(["question", "questions"]),
      date_time: "Date et heure",
      remove_question_warning: "Êtes-vous sûr de vouloir supprimer cette question ?",
      option: "Option",
      untitled_cluster: "Grille sans titre",
      untitled_title: "Title",
      title_label: "Titre",
      remove_cluster_warning: "Êtes-vous sûr de vouloir supprimer cette grille ?",
      value: "Valeur",
      choose_option: "Choisissez une option",
      questionnaire_settings: "Paramétrage du questionnaire",
      confirm: "Confirmer",
      cancel: "Annuler",
      rights: "Droits",
      notes_summary: "Notes et synthèse",
      option_placeholder: "Option",
      value_placeholder: "Note",
      comment_placeholder: "Ajouter un commentaire",
      option_settings: "Configuration des options",
      columns: "Colonnes",
      active: "Actif",
      unable: {
        confirmation: "Êtes-vous sûr de vouloir activer ce questionnaire ?",
        success: "Questionnaire activé avec succès !",
      },
      disable: {
        confirmation: "Êtes-vous sûr de vouloir désactiver ce questionnaire ?",
        success: "Questionnaire désactivé avec succès !",
      },
      global_export_visibility: "Visible sur l'export global du livret",
    },
    category: {
      title: ({ plural }) => plural(["Catégorie", "Catégories"]),
      add: "Ajouter une catégorie",
      delete_with_links: {
        title: "Supprimer la catégorie liée",
        sub_title:
          "Cette catégorie est reliée à des questionnaires, vous devez supprimer ces questionnaires afin de pouvoir supprimer cette catégorie. Voulez-vous vraiment continuer ?",
        success: "Catégorie liée supprimée avec succès !",
      },
    },
    mission: {
      title: ({ plural }) => plural(["Mission", "Missions"]),
    },
    group: {
      title: ({ plural }) => plural(["Groupe", "Groupes"]),
    },
    training: {
      title: ({ plural }) => plural(["Formation", "Formations"]),
      go_to_list: "Accéder à la liste des formations",
    },
    webLink: {
      title: ({ plural }) => plural(["Lien utile", "Liens utiles"]),
    },
    trainingCourse: {
      title: ({ plural }) => plural(["Promotion", "Promotions"]),
    },
    skill: {
      title: ({ plural }) => plural(["Compétence", "Compétences"]),
      list: {
        title: "Configuration des compétences",
        empty:
          "Il n'y a pas encore de compétence sur cette formation, veuillez créer une première catégorie pour commencer",
        empty_only: "Il n'y a pas encore de compétence renseignée",
      },
      actions: {
        add: "Ajouter une compétence",
        module_actions: "Configuration",
        skill_actions: "Gérer les compétences",
        session_actions: "Gérer les périodes",
        import_export_actions: "Import/Export",
        reminder_actions: "Relances",
        active_justificative: "Activer les preuves sur toutes les compétences",
        active_justificative_title: "Activer les preuves",
        active_justificative_activate_success: "Preuves activées sur les compétences avec succès !",
        active_justificative_unactivate_success: "Preuves désactivées sur les compétences avec succès !",
      },
      name: "Nom",
      level: "Niveau requis",
      default: {
        not_acquired: "Non acquis",
        acquired: "Acquis",
        expert: "Expert",
        being_acquired: "En cours d'acquisition",
        insufficient_mastery: "Maîtrise insuffisante",
        partial_mastery: "Maîtrise partielle",
        average_mastery: "Maîtrise moyenne",
        good_mastery: "Maîtrise bonne",
        excellent_mastery: "Maîtrise excellente",
      },
    },
    skill_configuration: {
      title: "Configuration du module",
      success: "Configuration mis à jour avec succès !",
      use_admin: "Utiliser la configuration admin ?",
      warning:
        "Attention ! Vous devez terminer la configuration du module des compétences afin de pouvoir intégrer un référentiel",
    },
    skill_referential: {
      title: "Gestion des référentiels de compétences",
      success: "Référentiels mis à jour avec succès !",
      warning:
        "Attention ! Vous devez terminer la configuration du module des compétences afin de pouvoir intégrer un référentiel",
      empty_add: "Il n'y a pas encore de référentiel, veuillez cliquer sur '+' pour en ajouter un",
    },
    skill_generate: {
      title: "Générer un questionnaire à partir des compétences",
      success: "Questionnaire généré avec succès !",
    },
    skill_remove: {
      title: "Supprimer le référentiel (sans les questionnaires)",
      sub_title: "Êtes-vous sûr de vouloir supprimer le référentiel",
      success: "Référentiel supprimé avec succès !",
    },
    skill_import: {
      title: "Importer vos compétences",
      success: "Compétences importées avec succès !",
    },
    skill_import_france_competence: {
      title: "Importer le référentiel France Compétences",
      confirm: "Êtes-vous sûr de vouloir charger le référentiel France Compétences sur cette formation ?",
      success: "Référentiel importé avec succès !",
    },
    skill_export: {
      title: "Exporter les compétences",
      success: "Compétences exportées avec succès !",
    },
    skill_export_taught: {
      title: "Exporter les matières",
      success: "Matières exportées avec succès !",
    },
    skillSession: {
      gestion: "Gestion des périodes de compétences",
      list: {
        title: "Configuration des périodes",
        empty: "Il n'y a pas encore de période, veuillez cliquer sur '+' pour en ajouter une",
      },
      title: ({ plural }) => plural(["Période", "Périodes"]),
    },
    skillReferential: {
      title: ({ plural }) => plural(["Référentiel", "Référentiels"]),
      use: "Utiliser un référentiel",
      empty: "Il n'y a pas encore de référentiel lié à cette période, veuillez cliquer sur le + pour en lier un",
    },
    skillCategory: {
      title: ({ plural }) => plural(["Catégorie", "Catégories"]),
    },
    skin: {
      title: ({ plural }) => plural(["Habillage", "Habillages"]),
      list: {
        title: "Habillage",
      },
    },
    gradebook: {
      title: ({ plural }) => plural(["Bulletin de note", "Bulletins de note"]),
      global_config: "Entête et pied de page",
      session_config: "Configuration des périodes",
      exam_type: "Liste des types d'examens",
      start_date: "Date d'ouverture : ",
      end_date: "Date de fermeture : ",
      empty_session: "Aucune période n'existe pour le moment, veuillez en ajouter une.",
      empty_subject: "Aucune matière n'est renseignée pour cette période, veuillez en ajouter une",
      empty_exam:
        "Aucun examen n'est renseigné pour cette matière, veuillez en selectionner un dans la configuration de la matière en cliquant ici",
      delete_session: {
        confirmation: "Êtes-vous sûr de vouloir supprimer cette période ?",
        success: "Période supprimée avec succès !",
      },
      delete_subject: {
        confirmation: "Êtes-vous sûr de vouloir retirer cette matière de la session ?",
        success: "Matière retirée avec succès !",
      },
      delete_exam: {
        confirmation: "Êtes-vous sûr de vouloir supprimer cet examen ?",
        success: "Examen retiré avec succès !",
      },
      scale: "Barème",
      set_exam_and_coef: "Renseigner le type d'examen et le coefficient pour cette matière",
    },
    exam: {
      title: ({ plural }) => plural(["Examen", "Examens"]),
      type_title: "Type d'examen",
    },
    triad: {
      title: ({ plural }) => plural(["Trinôme", "Trinômes"]),
      list: {
        name: "Nom",
        apprentice_name: "Nom de l'apprenti",
        tutor_name: "Nom du tuteur pédagogique",
        map_name: "Nom du tuteur entreprise",
        gestionnary_name: "Nom du gestionnaire",
      },
      registration: {
        contract_link_title: ({ named }) => "Voir le contrat" + (named("code") ? " : " + named("code") : ""),
        link_title: ({ named }) => "Voir la fiche d'inscription" + (named("code") ? " : " + named("code") : ""),
        reference: ({ named }) => "Inscription liée" + (named("code") ? " : " + named("code") : ""),
      },
      tutor: {
        title: ({ plural }) => plural(["Tuteur pédagigique", "Tuteurs pédagigiques"]),
      },
      map: {
        title: ({ plural }) => plural(["Tuteur en entreprise", "Tuteurs en entreprise"]),
      },
      questionnaire_triad_already_signed:
        "Attention, des signatures de \nquestionnaires sont rattachées \nà ce trinôme",
      usurp: {
        title: "Incarner",
      },
      login: {
        title: "Gérer l'envoi des identifiants",
      },
      delete_all: {
        tutor: "Supprimer tous les tuteurs pédagogiques",
        map: "Supprimer tous les tuteurs en entreprise",
      },
      delete: {
        tutor: "Supprimer ce tuteur pédagogique",
        map: "Supprimer ce tuteur entreprise",
        legal_responsible: "Supprimer ce responsable légal",
      },
      delete_member: {
        title: "Membre du trinôme",
      },
      delete_all_tutor: {
        title: "tous les tuteurs pédagogiques",
      },
      delete_all_map: {
        title: "tous les tuteurs en entreprise",
      },
      edit: {
        legal_responsible: "Modifier ce responsable légal",
        tutor: "Modifier ce tuteur pédagogique",
      },
      contract: {
        title: "Gestion des contrats",
      },
      complete: {
        title: "Ajouter un membre au trinôme",
      },
      actions: {
        title: "Actions",
      },
      add_test: "trinôme test",
      add_test_success: "Trinôme test ajouté avec succès !",
      send_user_infos: "Gérer l'envoi des identifiants",
      send_welcome_email: "Envoyer l'email de bienvenue avec les identifiants",
      send_welcome_email_success: "Email(s) de bienvenue envoyé(s) avec succès !",
      reset_password: "Réinitialiser le mot de passe et renvoyer l'identifiant",
      reset_password_success: "Email(s) de réinitialisation de mot de passe envoyé(s) avec succès !",
      activate_livret: "Activer le livret",
      deactivate_livret: "Désactiver le livret",
      livret_active_badge: "Livret actif",
      livret_inactive_badge: "Livret non activé",
      send_user_infos_message: "Cochez les utilisateurs et cliquez sur le type d'email que vous souhaitez leur envoyer",
      add_secondary_user: "Ajouter un utilisateur secondaire pour ce trinôme",
      add_secondary_user_success: "Utilisateur secondaire ajouté avec succès",
      remove_secondary_user: "Utilisateur secondaire supprimé avec succès",
    },
    studeaUser: {
      title: ({ plural }) => plural(["Utilisateur", "Utilisateurs"]),
    },
    user: {
      title: ({ plural }) => plural(["Utilisateur", "Utilisateurs"]),
    },
    crew: {
      title: ({ plural }) => plural(["Groupe", "Groupes"]),
      cannot_remove: "Vous ne pouvez pas supprimer un groupe qui contient des trinômes",
    },
    contract: {
      title: ({ plural }) => plural(["Contrat", "Contrats"]),
      empty: "Ce trinôme ne possède aucun contrat",
      dates: "Dates du contrat",
      company: "Entreprise",
      duration: "Durée",
      address: "Adresse",
      map: "MAP",
      manager: "Gestionnaire",
      contrat_type: "Type de contrat",
      rupture_date: "Date de rupture",
      contract_rupture_date: "Contrat en rupture au : ",
      dropped_out: "Abandon le : ",
      rupture_reason: "Motif de rupture",
      rupture_reason_text: "Commentaire",
      months: "mois",
      also_tutor: "Vous êtes tuteur de ce trinôme",
      incident_sheet: "Une fiche vigilance est en cours sur ce trinôme",
      no_current_access: "Vous n'avez plus accès à ce trinôme : un contrat plus récent a pris le relais",
    },
    template: {
      title: ({ plural }) => plural(["Modèle", "Modèles"]),
    },
    lesson: {
      title: ({ plural }) => plural(["Cours", "Cours"]),
    },
    skillType: {
      title: ({ plural }) => plural(["Type de compétence", "Types de compétences", "Type de compétences"]),
    },
    subject: {
      title: ({ plural }) => plural(["Matière", "Matières"]),
      former: {
        add: "Ajouter un formateur",
        add_new: "Ajouter un formateur qui n'est pas dans la liste",
        is_former: "Cet utilisateur est déjà formateur",
        is_studea_manager: "Cet utilisateur est pilote, lui attribuer un nouveau rôle pourrait changer ses droits",
        is_admin: "Cet utilisateur est administrateur, un profil pilote formateur lui sera ajouté",
        empty: "Aucun utilisateur trouvé, renseignez l'email , le nom et le prénom pour créer un nouveau formateur",
        add_success: "Formateur ajouté avec succès",
      },
    },
    unit: {
      title: ({ plural }) => plural(["Unité", "Unités"]),
    },
    planning: {
      title: ({ plural }) => plural(["Évènement", "Évènements"]),
      removeSelected: {
        title: "Supprimer les évènements sélectionnés",
        sub_title: "Êtes-vous sûr de vouloir supprimer ces évènements ?",
        sucess: "Évènements supprimés avec succès !",
      },
      end_of_recurrence: "Fin de la récurrence :",
    },
    trainingCourseModuleTriad: {
      title: ({ plural }) => plural(["Module", "Modules"]),
    },
    absence: {
      title: ({ plural }) => plural(["Absence", "Absences"]),
      list: {
        title: "Assiduité",
      },
      config: {
        title: "Configuration",
        success: "Configuration modifiée avec succès !",
      },
      export: {
        full_list: "Liste complète des absences",
        apprentice_list: "Liste des absences par ",
        excel: "(excel)",
        pdf: "(pdf)",
        state: "État des absences (planning)",
      },
      attestation: {
        title: "Publication d'attestation de présence",
      },
    },
    module: {
      title: ({ plural }) => plural(["Module", "Modules"]),
      active: {
        success: "Module activé avec succès !",
      },
      unactive: {
        success: "Module désactivé avec succès !",
      },
    },
    registration: {
      title: ({ plural }) => plural(["Inscription", "Inscriptions"]),
      list: {
        title: "Inscriptions",
      },
      go_to: "Accéder aux inscriptions",
    },
    notepad: {
      title: ({ plural }) => plural(["Bloc-notes", "Blocs-notes"]),
    },
    note: {
      title: ({ plural }) => plural(["Note", "Notes"]),
    },
    document: {
      title: ({ plural }) => plural(["Document", "Documents"]),
      pedagogic_documents: "Documents pédagogiques",
      general_documents: "Documents généraux",
      shared_documents: "Documents partagés",
      shared_document_add: "Ajout d'un document partagé",
      shared_document_edit: "Modifier un document partagé",
      shared_document_list: "Les documents partagés",
      shared_document_info:
        "Ce document est partagé, pour le modifier veuillez \n vous rendre dans la liste des documents partagés",
      trainingCourse_documents: "Documents de la promotion",
      error_file_or_link: "Veuillez ajouter un fichier ou saisir un lien",
      link: "lien",
    },
    "document/shared": {
      title: ({ plural }) => plural(["Document partagé", "Documents partagés"]),
    },
    incident_sheet: {
      title: ({ plural }) => plural(["Fiche vigilance", "Fiches vigilances"]),
      list: "Les fiches vigilances",
      add_comment: "Ajouter un commentaire",
      close: "Clôturer",
      close_confirmation: "Êtes-vous sur de vouloir clôturer cette fiche vigilance ?",
      open: "Ouvrir",
      open_confirmation: "Êtes-vous sur de vouloir réouvrir cette fiche vigilance ?",
      delete: "Supprimer",
      delete_confirmation: "Êtes-vous sur de vouloir supprimer cette fiche vigilance ?",
      in_progress: "En cours",
      closed: "Clôturée",
      search: "Rechercher une fiche vigilance",
      see_sheet: "Voir la fiche incident",
      see_questionnaire: "Voir le questionnaire",
      comment: "Commentaire",
      status: "Statut",
      no_status: "Pas de statut",
    },
    currently: "actuellement",
    documentExchange: {
      list: {
        title: "Échange de docs",
      },
    },
    messaging: {
      list: {
        title: "Messagerie",
      },
    },
    dashboard: {
      list: {
        title: "Tableau de bord",
      },
      please_use_filter_to_see_data: "Veuillez utiliser les filtres pour pouvoir visualiser les données",
      signature_cancel_confirmation: "Êtes vous sûr(e) de vouloir annuler la signature ?",
      filter: "Filtrer",
      delete_filters: "Réinitialiser les filtres",
      questionnaire: {
        unlocked_confirmation: "Voulez-vous débloquer ce questionnaire ?",
        locked_confirmation: "Voulez-vous bloquer ce questionnaire ?",
        unlocked_all_confirmation: "Voulez-vous débloquer tous les questionnaires de cette colonne ?",
        unlock_all_questionnaires: "Débloquer tous les questionnaires de cette colonne",
        unlock_questionnaire: "Débloquer ce questionnaire",
        opening_date_on: "Date d'ouverture au",
        lock_questionnaire: "Bloquer ce questionnaire",
        cancel_signature: "Annuler cette signature",
        send_email_reminder: "Relancer par mail",
        send_email_reminder_confirmation: "Êtes-vous sur de vouloir effectuer une relance par mail ?",
        send_email_reminder_success: "Relances envoyées avec succès !",
        send_email_reminder_no_mail:
          "Aucune relance envoyée : les conditions ne sont pas encore remplies (les répondants n'ont pas tous signé).",
        success_all_unlock: "Questionnaires débloqués avec succès !",
        success_unlock: "Questionnaire débloqué avec succès !",
        success_lock: "Questionnaire bloqué avec succès !",
        success_cancel_signature: "Signature annulée avec succès !",
        to_much_data: "Trop de données selectionnées, veuillez affiner votre recherche",
        table_lock: "Figer les questionnaires",
        table_unlock: "Ne pas figer les questionnaires",
      },
      mail_relance: {
        title: "Relance par mail",
        subtitle: "Les relances ne seront pas envoyées aux questionnaires verrouillés (cadenas fermé)",
      },
      email_reminder: "Relancer par mail",
      export: {
        title: "Exporter",
        all_promotion_replies: "Exporter l'ensemble des réponses de la promotion",
        all_promotion_replies_to_excel: "Exporter l'ensemble des réponses de la promotion au format Excel",
        visit_date: "Exporter les dates de visite en entreprise",
        dashboard_excel: "Exporter le tableau de bord au format Excel",
        questionnaires_pdf: "Exporter les questionnaires",
      },
      roles: {
        alternate: "Alternant",
        educational_tutor: "Tuteur pédagogique",
        company_tutor: "Tuteur en entreprise",
        lea_manager: "Chargé de léa",
      },
      go_to_questionnaire: "Accéder au questionnaire",
    },
    gradeBookDashboard: {
      list: {
        title: "Tableau des notes",
      },
      export_dashboard_excel: "Exporter le tableau des notes au format Excel",
      caption: {
        danger: "Note entre la note minimale et la moyenne inférieure",
        success: "Note entre la moyenne supérieure et la note maximale",
      },
    },
    skillDashboard: {
      list: {
        title: "Tableau de bord des compétences",
      },
      export_dashboard_excel: "Exporter le tableau des compétences au format Excel",
      skill: {
        acquired: "Acquis",
        in_progress: "En cours",
        not_acquired: "Non acquis",
      },
    },
    export: {
      list: {
        title: "Exports",
      },
    },
    mail: {
      list: {
        title: "Suivi des mails",
        empty: "Aucun mail n'a été envoyé pour le moment",
      },
      view: "Voir le contenu du mail",
      data: "Donnée du mail",
    },
    history: {
      list: {
        title: "Historique des connexions",
      },
    },
    assiduite: "Gestion de l'assiduité",
    subscriptions_dashboard: "Tableau de bord des inscriptions",
    import: {
      modele: "Modèle de fichier à télécharger",
      defaultModele: "Modèle de fichier à télécharger (modèle par défaut)",
      triad_new_file:
        "Attention, un nouveau modèle est disponible depuis le 18/09/2023.\n" +
        "          Merci de le télécharger et de l'utiliser pour charger vos trinômes.",
      triad_update:
        "Attention, seuls les membres manquants d'un trinôme seront mis à jour. Aucune donnée (nom, prénom ou email) d'un utilisateur existant ne sera mise à jour.",
      thanks: "Merci de ne pas modifier et / ou supprimer les colonnes du modèle",
    },
    download_file_here: "Télécharger le fichier ICI",
    session: {
      from: "Du",
      to: "au",
      title: ({ plural }) => plural(["Période", "Périodes"]),
    },
    user_never_connected: "Cet utilisateur ne s'est jamais connecté",
    welcome_mail_send: ({ named }) => `Email de bienvenu a été envoyé ${named("number")} fois`,
    reset_password_mail_send: ({ named }) => `Email de réinitialisation a été envoyé ${named("number")} fois`,
    see_last_mail_content: "Voir le contenu du dernier Email envoyé",
    duplication: "Duplication de données",
    duplication_historic: "Historique des duplications",
    search_duplication: "Rechercher des duplications",
    see_duplication: "Voir toutes les informations de cette duplication",
    duplication_date: "Date de fin d'execution",
    duplication_too_old: "Vous ne pouvez pas relancer une duplication vieille de plus de 15 jours.",
    duplication_status: {
      pending: "En cours",
      done: "Finie",
      failed: "Échouée",
    },
    reload_duplication: {
      title: "Relancer cette duplication",
      confirmation: "Êtes-vous sûr de vouloir relancer cette duplciation",
    },
    details: "Détails",
    status: "Statut",
    statistic: {
      title: ({ plural }) => plural(["Statistique", "Statistiques"]),
      shared_documents: "Trinomes incomplets",
      calculation_in_progress: "Calcul des indicateurs en cours.",
      calculation_refresh: "Veuillez patienter un instant ou rafraichir votre page pour actualiser le calcul",
    },
    driver_licence: {
      title: "Permis b",
      requests: "Demandes d'aide au permis B",
      list: "Liste des demandes d'aide au permis B",
      valid: "Valider la demande d'aide",
      valid_confirmation: "Êtes-vous sur de vouloir valider cette demande ?",
      export: "Exporter la liste des demandes d'aide",
      edit: "Modifier la demande de : ",
      overview: "Aperçu de la demande de : ",
      request_edit: {
        success: "Demande d'aide au permis B modifié avec succès",
      },
    },
    company: {
      title: ({ plural }) => plural(["Entreprise", "Entreprises"]),
    },
    apprentice: {
      title: ({ plural }) => plural(["Apprenti", "Apprentis"]),
    },
    duplicated: {
      relaunch: "Relancer",
      reference: "Référence",
      destination: "Destination",
      type: "Type de duplication",
      confirmation: "Êtes-vous sûr de vouloir dupliquer ces données",
      action: {
        replace: "Remplacer",
        add: "Ajouter",
        crush: "Écraser",
        options: {
          title: "Options",
          add_to_current_year: "Ajouter à l'année en cours",
          empty_training_course: "Uniquement sur les promotions vides",
          add_to_due_date: "Ajouter une année aux dates d'échéances",
          overwrite_current_year_only: "Écraser uniquement l'année en cours",
        },
      },
      questionnaire: {
        already_sign_not_affected: "Les questionnaires déjà signés ne seront pas impactés",
        copy_even_if_already_existing: "Les questionnaires seront copiés même si il en existe déjà",
        replace_questionnaire_with_same_name_questionnaire:
          "Les questionnaires portant le <strong>même nom</strong> seront remplacés",
        replace_all: "Les questionnaires existants seront supprimés",
      },
      transition_report: {
        title: "Promotions non traitées",
        destination: "Destination",
        questionnaire_count: ({ plural }) => plural(["questionnaire", "questionnaires"]),
        status_resolved: "Traitée",
        status_blocked: "Bloquée",
        status_skipped: "Ignorée",
        status_would_create: "Promotion à créer",
        step_same_training: "Même formation",
        step_code_formation_acronym: "Code formation + acronyme",
        step_code_formation_name: "Code formation + nom",
        step_code_formation_year_number: "Code formation + année",
      },
      training_course: {
        duplicated_data: "Données dupliquées",
        add_data_if_empty: "Ajoute les données si elles n'existent pas",
        duplicate_choice: "Vous souhaitez dupliquer",
        duplicate_from_reference: "Permet de copier un livret type sur un ensemble de promotion",
        duplicate_from_year: "Permet d'ajouter une année en dupliquant la configuration de l'année précédente",
      },
    },
    trainingPeriod: {
      title: ({ plural }) => plural(["Semestre", "Semestres"]),
    },
    file: {
      title: ({ plural }) => plural(["Fichier", "Fichiers"]),
    },
    institution: {
      title: ({ plural }) => plural(["Établissement", "Établissements"]),
    },
    component: {
      title: ({ plural }) => plural(["Composante", "Composantes"]),
    },
    livretConfig: {
      title: "Activation du livret",
    },
  },
  add_session: "Ajouter une période",
  edusign: {
    title: "Edusign",
    synchronize: {
      title: "Lancer la synchronisation chez Edusign",
      confirmation: "Êtes-vous sûr de vouloir lancer la synchronisation chez Edusign ?",
    },
    get_data: {
      title: "Récupérer les absences et présences",
      confirmation: "Êtes-vous sûr de vouloir récupérer les absence et présences d'Edusign ?",
    },
  },
  uniservice: {
    title: "Uniservice",
    get_data: {
      title: "Récupérer les présences",
      confirmation: "Êtes-vous sûr de vouloir récupérer les présences d'Uniservice ?",
    },
    reset: {
      title: "Réinitialiser les présences et absences",
      confirmation: "Êtes-vous sûr de vouloir supprimer les présences et absences des plannings non validés ?",
    },
  },
};
